<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="6.346" height="11.145" viewBox="0 0 6.346 11.145">
		<path
			id="Path_29279"
			data-name="Path 29279"
			d="M9.447.123,5.072,4.389.7.123a.4.4,0,0,0-.574,0A.393.393,0,0,0,0,.41.371.371,0,0,0,.109.684L4.771,5.223a.43.43,0,0,0,.6,0L10.035.7A.427.427,0,0,0,10.145.4a.379.379,0,0,0-.123-.287A.407.407,0,0,0,9.735,0a.391.391,0,0,0-.287.123Z"
			transform="translate(0.5 10.645) rotate(-90)"
			fill="none"
			stroke="#5a677d"
			stroke-width="1"
		/>
	</svg>
</template>

<script>
export default {
	name: 'CaretSvg',
};
</script>

<style scoped lang="scss"></style>
